<template>
  <!-- v-if="pending !== 1" -->
  <div class="pending-wrapper">
    <!-- 成功状态 ,TODO billingAddress直接取order数据行不行,redirectUrl取order.data.redirectUrl是否可以-->
    <Modal :modelValue="currentStatus === CHECKOUT_STATUS.SUCCESS"
      :title="this.$t('message.result.success')"
      :description="modalMessage || this.$t('message.result.successPop')"
      :status="'success'"
      :buttonText="this.$t('message.checkout.returnMerchant')"
      :redirectUrl="redirectUrl"
      :billingAddress="billingAddress"
    />
    <!-- 失败状态 -->
    <Modal :modelValue="currentStatus === CHECKOUT_STATUS.FAILED"
      :title="this.$t('message.result.failed')"
      :description="modalMessage ? `${this.$t('message.result.reason')}: ${modalMessage}` : ''"
      :status="'error'"
      :buttonText="this.$t('message.checkout.returnMerchant')"
      :redirectUrl="redirectUrl"
    />
    <!-- Loading -->
    <LoadingArrow v-if="currentStatus === CHECKOUT_STATUS.LOADING"  />
    <!-- 提交中 -->
    <LoadingArrow
      v-if="currentStatus === CHECKOUT_STATUS.SUBMITTING || currentStatus === CHECKOUT_STATUS.PENDING"
      :text="this.$t('message.result.processing')"
    />
    <!-- 错误 -->
    <ErrorPage v-if="currentStatus === CHECKOUT_STATUS.ERROR" />
  </div>

</template>
<script>

import { getStatus, getBrandInfo } from '@/api/checkout';
import ErrorPage from '@/componentsV2/busi/Error/Error.vue';
import LoadingArrow from '@/componentsV2/busi/Loading/LoadingArrow.vue';
import Modal from '@/componentsV2/busi/Modal/Modal.vue';
import { deviceFingerprintManager } from '@/plugins/eventTrackManager/deviceFingerprintManager';
import { getCheckoutType, sendGaResultEvent } from '@/utils/tools/ga';

// 导入状态常量
import { CHECKOUT_STATUS, exceptionShow } from '@/views/checkout/pc/config';

export default {
  components: {
    Modal,
    LoadingArrow,
    ErrorPage,
  },
  data() {
    return {
      CHECKOUT_STATUS,
      currentStatus: CHECKOUT_STATUS.PENDING,
      percent: 10,
      tryCount: 0,
      tryInterval: 1000,
      pending: 1,
      type: '',
      orderInfo: null,
      resultPopup: {
        visible: false,
        popupStatus: '',
        popupTitle: '',
        popupText: '',
        showReturnBtn: true,
        redirectUrl: '',
      },
      modalMessage: '',
      redirectUrl: '',
      billingAddress: '',
    };
  },

  created() {
    this.type = getCheckoutType(this.$route.query.type, this.$route.query.key);
    getBrandInfo(this.$route.query.key).then((res) => {
      if (res.respCode === '20000' && res.data) {
        this.$store.dispatch('app/setBrandInfo', res.data);
      }
    }).catch(() => ({}));
    const status = this.$route.query.status;
    // s0状态下, 重试次数为1, 重试间隔为1s
    if (status !== 's0') {
      this.pending = 16;
    }
    this.getOrderStatus();
    window.addEventListener('beforeunload', this.beforeUnloadEvent);
  },
  beforeDestroy() {
    this.sendGaEvent('exit_payment_result_page');
    this.sendRiskDeviceFingerPrint('exit_payment_result_page');
    window.removeEventListener('beforeunload', this.beforeUnloadEvent);
  },
  methods: {
    /**
     * 修改结账状态
     * @param {string} status - 状态值
     * @param {string} message - 错误信息
     */
    setCheckoutStatus(status, message, others) {
      if (Object.values(CHECKOUT_STATUS).includes(status)) {
        this.currentStatus = status;
        this.modalMessage = message;
        this.redirectUrl = others?.redirectUrl;
        this.billingAddress = others?.billingAddress;
        // 如果是pending状态，则调用轮询订单状态.
        // if (status === CHECKOUT_STATUS.PENDING) {
        //   this.getOrderStatus().catch((error) => {
        //     this.setCheckoutStatus(error.status, error.message, error.others);
        //   });
        // }
      } else {
        this.currentStatus = CHECKOUT_STATUS.ERROR;
        console.error('Invalid checkout status:', status);
      }
    },
    getOrderStatus() {
      this.tryCount += 1;
      getStatus(this.$route.query.key ? this.$route.query.key : this.$route.params.id).then(res => {
        if (res.respCode === '20000') {
          this.orderInfo = res.data;
          if (res.data.status === 'S') { // 成功
            this.setCheckoutStatus(CHECKOUT_STATUS.SUCCESS, '', {
              redirectUrl: res.data.subscriptionManageUrl || res.data.redirectUrl,
              billingAddress: !res.data.hideBillingInformation ? res.data.billingAddress : '',
            });
            return;
          } else if (res.data.status === 'F') { // 失败
            if (res.data.retry === '1') {
              this.$router.push({
                path: '/aggregate',
                query: { key: this.$route.query.key },
              });
              return;
            }
            this.setCheckoutStatus(
              CHECKOUT_STATUS.FAILED,
              res.data?.message || res.respMsg || '',
              {
                redirectUrl: res.data.redirectUrl,
              },
            );
            return;
          } else if (res.data.status === 'P' || res.data.status === 'R') { // 等待/重定向
            if (this.tryCount < this.pending) { // 重试
              setTimeout(() => {
                this.getOrderStatus();
              }, this.tryInterval);
            } else {
              if (res.data.status === 'P' || !res.data.redirectUrl) {
                this.setCheckoutStatus(
                  CHECKOUT_STATUS.ERROR,
                );
                return;
              } else {
                this.setCheckoutStatus(
                  CHECKOUT_STATUS.ERROR,
                );
                return;
              }
            }
          } else {
            this.setCheckoutStatus(
              CHECKOUT_STATUS.ERROR,
            );
            return;
          }
        } else {
          if (res.data.retry === '1') {
            this.$router.push({
              path: '/aggregate',
              query: { key: this.$route.query.key },
            });
            return;
          }
          // 超时订单处理
          if (res.respCode === '00020|50054' || res.respCode === '50054') {
            if (this.tryCount < this.pending) {
              setTimeout(() => {
                this.getOrderStatus();
              }, this.tryInterval);
            } else {
              // this.resultPopup = {
              //   visible: true,
              //   popupStatus: 'failed',
              //   popupTitle: this.$t('message.result.unknow'),
              //   popupText: this.$t('message.result.unknowTip'),
              //   showReturnBtn: false,
              //   redirectUrl: res.data.redirectUrl,
              // };
              this.setCheckoutStatus(
                CHECKOUT_STATUS.ERROR,
              );
              return;
            }
            return;
          }
          let isContinue = exceptionShow(res, true).catch((e) => {
            this.setCheckoutStatus(
              e.status,
              e.message,
              e.others,
            );
            isContinue = true;
          });
          if (isContinue) {
            return;
          }
          // if (exceptionShow(res.respCode, this.$router, this.$route.query.key ? this.$route.query.key : this.$route.params.id, this.type)) {
          this.setCheckoutStatus(
            CHECKOUT_STATUS.FAILED,
            '',
            {
              redirectUrl: res.data.redirectUrl,
            },
          );
          // this.resultPopup = {
          //   visible: true,
          //   popupStatus: 'failed',
          //   popupTitle: this.$t('message.result.failed'),
          //   // TODO 多语言？
          //   popupText: '',
          //   redirectUrl: res.data.redirectUrl,
          // };
          return;
        }
        if (this.tryCount === 1) {
          this.sendGaEvent('visit_payment_result_page');
          this.sendRiskDeviceFingerPrint('visit_payment_result_page');
        }
      }).catch(() => {
        if (this.tryCount === 1) {
          this.sendGaEvent('visit_payment_result_page');
          this.sendRiskDeviceFingerPrint('visit_payment_result_page');
        }
        if (this.tryCount < this.pending) { // 重试
          setTimeout(() => {
            this.getOrderStatus();
          }, this.tryInterval);
        } else {
          this.setCheckoutStatus(
            CHECKOUT_STATUS.ERROR,
          );
          // this.resultPopup = {
          //   visible: true,
          //   popupStatus: 'failed',
          //   popupTitle: this.$t('message.result.unknow'),
          //   popupText: this.$t('message.result.unknowTip'),
          //   showReturnBtn: false,
          // };
        }
      });
    },
    sendGaEvent(eventName) {
      sendGaResultEvent(this.$route.query.type, this.$route.query.key, this.orderInfo, eventName);
    },
    beforeUnloadEvent() {
      this.sendGaEvent('exit_payment_result_page');
      this.sendRiskDeviceFingerPrint('exit_payment_result_page');
    },
    sendRiskDeviceFingerPrint(event) {
      const param = {
        m: this.$route.query.merchantTxnId || '',
        e: event,
      };
      deviceFingerprintManager.send(param);
    },

  },
};
</script>
<style lang="scss">
.layout-wrapper {
  height: 100vh;
  position: relative;

}

.header-wrapper {
  display: none;
}

.footer-box {
  display: none;
}

.content-wrapper {
  height: 100vh;
  padding-top: 0 !important;

}
</style>
<style scoped lang="scss">
.process-box {
  position: relative;
  display: inline-block;

  .process-item {
    animation: 1.5s linear 0s normal none infinite rotate;
  }

  .wallet {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .custom_loading {
    font-size: 32px;
    color: #182058;
  }
}

.ellipsis {
  position: absolute;
}

.pending-wrappe {
  position: relative;
  width: 100%;
  height: 100%;
}

.result-box {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding-top: 0 !important;

  .pending {
    margin-top: 6px;
    color: #182058;
  }
}
</style>
